import Glide from "@glidejs/glide";

// Initialize Post Card Slider
const beforeAndAfterCardRowSliderHandler = () => {
	const beforeAndAfterCardRowSliders = document.querySelectorAll(".before-and-after-card-row__glide");

	beforeAndAfterCardRowSliders.forEach((slider, i) => {
		const autoplay = slider.dataset.autoplay;
		const slidesPerView = slider.dataset.slidesPerView;
		
		// Check if the slider has already been initialized
		if (!slider.hasAttribute("data-initialized")) {
			new Glide(slider, {
				type: "carousel",
				startAt: 0,
				perView: Number(slidesPerView),
				autoplay: Number(autoplay),
				gap: 25,
				breakpoints: {
					1024: { perView: Math.min(Number(slidesPerView), 2) },
					640: { perView: 1, peek: 40 },
				},
			}).mount();
			
			// Mark the slider as initialized
			slider.setAttribute("data-initialized", "true");
		}
	});
};

// Initialize everything when DOM is ready
if (document.readyState !== "loading") {
	beforeAndAfterCardRowSliderHandler();
} else {
	document.addEventListener("DOMContentLoaded", () => {
		beforeAndAfterCardRowSliderHandler();
	});
}
